import { IGetProductResponse } from '../../types/products';
import { axiosInstance } from '../axiosInstance';

export const getProduct = async (id: string): Promise<IGetProductResponse> => {
  const response = await axiosInstance.get(`/view/products/${id}`);

  return response.data;
};
